import type { SceneDialogueStats } from '@narrativebench/editor-core';

export type FormattedSceneDialogueStatLabels = {
  scenes?: string;
  dialogWords: string;
  dialogEstimation: string;
};

export function formatSceneDialogueStatLabels(
  stats: SceneDialogueStats & { sceneCount?: number },
  t: (key: string) => string,
): FormattedSceneDialogueStatLabels {
  const wordsUnit = stats.wordCount === 1 ? t('word') : t('word_plural');
  const timeUnit = stats.estimatedMinutes === 1 ? t('min') : t('mins');
  const labels: FormattedSceneDialogueStatLabels = {
    dialogWords: t('script_dialog_words')
      .replace('{count}', String(stats.wordCount))
      .replace('{unit}', wordsUnit),
    dialogEstimation: t('script_dialog_estimation')
      .replace('{count}', String(stats.estimatedMinutes))
      .replace('{unit}', timeUnit),
  };
  if (typeof stats.sceneCount === 'number' && stats.sceneCount > 0) {
    labels.scenes = t('script_scenes').replace('{count}', String(stats.sceneCount));
  }
  return labels;
}
